// language=GraphQL
export const ALL_ITEMS_QUERY = `query Query($withImage: Boolean = false, $withMapMarkers: Boolean = false) {
  items: itineraryItems {
    id
    duration
    title
    text
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    mapMarkers @include(if: $withMapMarkers) {
      id
      lat
      lng
    }
  }
}`

// language=GraphQL
export const SINGLE_ITEM_QUERY = `query Query($id: ID!, $withImage: Boolean = false, $withMapMarkers: Boolean = false) {
  item: itineraryItem(id: $id) {
    id
    duration
    title
    text
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    mapMarkers @include(if: $withMapMarkers) {
      id
      lat
      lng
    }
  }
}`

// language=GraphQL
export const CREATE_ITEM_MUTATION = `
  mutation Mutation($input: CreateItineraryItemInput, $withImage: Boolean = false, $withMapMarkers: Boolean = false) {
    item: createItineraryItem(input: $input) {
      id
      duration
      title
      text
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mapMarkers @include(if: $withMapMarkers) {
        id
        lat
        lng
      }
    }
  }`

// language=GraphQL
export const UPDATE_ITEM_MUTATION = `
  mutation Mutation($input: UpdateItineraryItemInput, $withImage: Boolean = false, $withMapMarkers: Boolean = false) {
    item: updateItineraryItem(input: $input) {
      id
      duration
      title
      text
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mapMarkers @include(if: $withMapMarkers) {
        id
        lat
        lng
      }
    }
  }`

// language=GraphQL
export const DELETE_ITEM_MUTATION = `
  mutation Mutation($input: DeleteItineraryItemInput) {
    deleteItineraryItem(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ITEM_MUTATION = `
  mutation Mutation($input: DeleteItineraryItemInput) {
    forceDeleteItineraryItem(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ITEM_MAP_MARKERS_MUTATION = `
  mutation Mutation($input: addItineraryItemMapMarkersInput) {
    addItineraryItemMapMarkers(input: $input) {
      id
      mapMarkerIds
    }
  }`

// language=GraphQL
export const REMOVE_ITEM_MAP_MARKERS_MUTATION = `
  mutation Mutation($input: removeItineraryItemMapMarkersInput) {
    removeItineraryItemMapMarkers(input: $input) {
      id
      mapMarkerIds
    }
  }`

// language=GraphQL
export const CREATE_ITEM_MAP_MARKERS_MUTATION = `
  mutation Mutation($input: createItineraryItemMapMarkersInput) {
    createItineraryItemMapMarkers(input: $input) {
      id
      mapMarkerIds
    }
  }`

// language=GraphQL
export const DELETE_ITEM_MAP_MARKERS_MUTATION = `
  mutation Mutation($input: deleteItineraryItemMapMarkersInput) {
    deleteItineraryItemMapMarkers(input: $input) {
      id
      mapMarkerIds
    }
  }`

// language=GraphQL
export const UPDATE_ITEM_MAP_MARKERS_ORDER_MUTATION = `
  mutation Mutation($input: updateItineraryItemMapMarkersOrderInput) {
    updateItineraryItemMapMarkersOrder(input: $input) {
      id
      mapMarkerIds
    }
  }`

// language=GraphQL
export const ITEMS_DEPENDENTS_QUERY = `query Query($id: ID!, $withItineraries: Boolean = false) {
  groupedDependents: itineraryItemDependents(id: $id) {
    itineraries @include(if: $withItineraries) {
      id
    }
  }
}`
